import styled from 'styled-components';

const monoStack =
  "'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";

export const FooterContainer = styled.footer`
  position: fixed;
  bottom: 0;
  right: 48px;
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-family: ${monoStack};
  font-size: 0.7rem;
  color: ${({ theme }) => theme.text};
  z-index: 1000;
  padding: 0.2rem 0 0.65rem;
`;

export const FooterLink = styled.button`
  background: ${({ theme }) =>
    theme.name === 'short'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.05) 100%)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.04) 100%)'};
  border: 1px solid ${({ theme }) =>
    theme.name === 'short' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)'};
  border-radius: 999px;
  color: inherit;
  font-family: ${monoStack};
  font-size: 0.6rem;
  letter-spacing: 0.07em;
  cursor: pointer;
  padding: 0.32rem 0.62rem;
  opacity: 0.88;
  text-decoration: none;
  line-height: 1;
  box-shadow: inset 0 1px 0
    ${({ theme }) => (theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)')};
  transition:
    transform 0.16s ease,
    opacity 0.2s ease,
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
    border-color: ${({ theme }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.46)' : 'rgba(0, 0, 0, 0.28)'};
    background: ${({ theme }) =>
      theme.name === 'short'
        ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%)'
        : 'linear-gradient(180deg, rgba(0, 0, 0, 0.16) 0%, rgba(0, 0, 0, 0.06) 100%)'};
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 2px ${({ theme }) =>
        theme.name === 'short' ? 'rgba(255, 255, 255, 0.24)' : 'rgba(0, 0, 0, 0.16)'},
      inset 0 1px 0
        ${({ theme }) => (theme.name === 'short' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.08)')};
  }
`;

export const Copyright = styled.span`
  opacity: 0.56;
  font-size: 0.57rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-left: 0.25rem;
`;

export const PopoverWrapper = styled.div`
  position: relative;
`;

export const Popover = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 10px;
  background: ${({ theme }) =>
    theme.name === 'short'
      ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0.05) 100%), rgba(0, 0, 255, 0.96)'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.03) 100%), rgba(255, 204, 213, 0.96)'};
  border: 1px solid ${({ theme }) =>
    theme.name === 'short' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)'};
  border-radius: 14px;
  padding: 20px 24px;
  width: clamp(310px, 30vw, 360px);
  max-height: 60vh;
  overflow-y: auto;
  z-index: 2400;
  font-family: ${monoStack};
  box-shadow:
    inset 0 1px 0 ${({ theme }) =>
      theme.name === 'short' ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.1)'},
    0 18px 38px ${({ theme }) =>
      theme.name === 'short' ? 'rgba(0, 0, 0, 0.28)' : 'rgba(0, 0, 0, 0.12)'};
  backdrop-filter: blur(7px);
`;

export const PopoverTitle = styled.h3`
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 0 0 0.25rem 0;
  color: ${({ theme }) => theme.text};
  opacity: 0.92;
`;

export const EffectiveDate = styled.p`
  font-size: 0.58rem;
  color: ${({ theme }) => theme.text};
  opacity: 0.6;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 0 0 1rem 0;
`;

export const SectionTitle = styled.h4`
  font-size: 0.66rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 1rem 0 0.5rem 0;
  color: ${({ theme }) => theme.text};
  opacity: 0.9;
`;

export const Paragraph = styled.p`
  font-size: 0.67rem;
  line-height: 1.58;
  color: ${({ theme }) => theme.text};
  opacity: 0.8;
  margin: 0 0 0.5rem 0;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem 0;
`;

export const ListItem = styled.li`
  font-size: 0.67rem;
  line-height: 1.7;
  color: ${({ theme }) => theme.text};
  opacity: 0.78;
  padding-left: 1rem;
  position: relative;

  &::before {
    content: '\u2022';
    position: absolute;
    left: 0;
  }
`;
